import React, {useState} from 'react'
import {message, Table, Typography} from "antd"
import ClubMemberFindTrackRound from "./ClubMemberFindTrackRound"
import ClubMemberFindTrackCommodity from "./ClubMemberFindTrackCommodity"
import {getClubMemberTrackBillDetail} from "../../../../../../../api/clubMemberList"

const ClubMemberFindTrackBuy = ({loading, datasource}) => {

    const [isLoading, setIsLoading] = useState(false)
    const [commodityRecord, setCommodityRecord] = useState([])
    const [roundList, setRoundList] = useState([])
    const [price, setPrice] = useState(0)
    const columns = [
        {
            title: '俱乐部名称',
            dataIndex: 'club_name',
            key: 'club_name',
        },
        {
            title: '订单号',
            dataIndex: 'temporary_number',
            key: 'temporary_number',
            render: (text) => (<Typography.Text copyable>{text}</Typography.Text>)
        },
        {
            title: '流水号',
            dataIndex: 'serial_number',
            key: 'serial_number',
            render: (text) => (<Typography.Text copyable>{text}</Typography.Text>)
        },
        {
            title: '商品名',
            dataIndex: 'commodity_name',
            key: 'commodity_name',
        },
        {
            title: '单价',
            dataIndex: 'uprice',
            key: 'uprice',
            render: (text) => {
                return <span>{(text / 100).toFixed(2)}</span>
            },
        },
        {
            title: '数量',
            dataIndex: 'num',
            key: 'num',
        },
        {
            title: '总价',
            dataIndex: 'price',
            key: 'price',
            render: (text) => {
                return <span>{(text / 100).toFixed(2)}</span>
            },
        },
    ]

    const fetchCommodityRecord = async (sn) => {
        setIsLoading(true)
        await getClubMemberTrackBillDetail(sn).then((res) => {
            setCommodityRecord(res.goodsList)
            setRoundList(res.list)
            setPrice(res.prices)
        }).catch((err) => {
            message.error(err)
        }).finally(() => {
            setIsLoading(false)
        })
    }


    return (
        <div>
            <Table
                loading={loading}
                columns={columns}
                dataSource={datasource}
                rowKey={record => record.id}
                expandable={{
                    onExpand: (_, record) => {
                        fetchCommodityRecord(record.serial_number)
                    },
                    expandedRowRender: () => {
                        return (
                            <div>
                                <div style={{padding: 16}}>付款金额：￥{price}</div>
                                <ClubMemberFindTrackRound loading={isLoading} datasource={roundList}/>
                                <ClubMemberFindTrackCommodity loading={loading} datasource={commodityRecord}/>
                            </div>
                        )
                    },
                    rowExpandable: record => record.serial_number !== null,
                }}
            />
        </div>
    )
}

export default ClubMemberFindTrackBuy


// WEBPACK FOOTER //
// ./src/containers/ClubMemberList/component/ClubMemberFind/component/ClubMemberFindTrack/component/ClubMemberFindTrackBuy.js